import { IconFileType, Pagination } from '@app/components/index'
import { useDocuments } from '@app/lib'
import { ActionIcon, Box, createStyles, LoadingOverlay, Paper, type PaperProps, Table } from '@mantine/core'
import { IconDownload } from '@tabler/icons-react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { map } from 'lodash'
import { type FC, useState } from 'react'

dayjs.extend(relativeTime)

const useStyles = createStyles(() => ({
  actionColumn: {
    textAlign: 'center',
    verticalAlign: 'center',
    width: 64
  },
  typeColumn: {
    textAlign: 'center',
    verticalAlign: 'center',
    width: 50
  }
}))

export interface DocumentsTableProps extends Omit<PaperProps, 'children'> {}

export const DocumentsTable: FC<DocumentsTableProps> = (props) => {
  const [page, setPage] = useState(1)
  const { data: documents, isFetching: isFetchingDocuments } = useDocuments(page)
  const { classes, theme } = useStyles()

  return (
    <Paper
      p='lg'
      {...props}
    >
      <Box pos='relative'>
        <LoadingOverlay visible={isFetchingDocuments} />
        <Table
          mb='xl'
          horizontalSpacing='xs'
          verticalSpacing='xs'
        >
          <thead>
            <tr>
              <th className={classes.typeColumn}>Type</th>
              <th>Name</th>
              <th>Category</th>
              <th>Status</th>
              <th className={classes.actionColumn}>Action</th>
            </tr>
          </thead>
          <tbody>
            {map(documents?.data, (document, idx) => (
              <tr key={`document-${idx}`}>
                <td className={classes.typeColumn}>
                  <IconFileType
                    color={theme.colors.navy[6]}
                    fileExt={document.fileExt}
                  />
                </td>
                <td>{document.reportDisplayName}</td>
                <td>{document.subCategoryDisplay}</td>
                <td>{document.status ?? '-'}</td>
                <td className={classes.actionColumn}>
                  <ActionIcon
                    color='navy'
                    component='a'
                    href={`/api/documents/${document.id}`}
                    tabIndex={0}
                    title='Download Document'
                    variant='transparent'
                  >
                    <IconDownload size={16} />
                  </ActionIcon>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          onChange={setPage}
          total={documents?.pagination?.totalPages || 1}
          value={page}
        />
      </Box>
    </Paper>
  )
}
